// ── Design decisions ──
// Segmentado de 3 botones porque son exactamente tres regímenes y el operador
// necesita verlos todos de un vistazo (un <select> escondería la opción que no
// eligió). El ícono de info lleva el resumen de umbrales en el title: la regla
// fiscal vive en un solo string para no repetirla por pestaña.
// Cuando value es null mostramos "Sin tipo" en ámbar: no bloquea el cierre,
// pero sí es una advertencia.
//
// `ambiance` (sólo el ExtractionDrawer) cambia la piel por los tokens de
// ambiance.css. Ahí el activo NO es un solo color: cada régimen tiene el suyo
// para que se distingan de un vistazo — Pasajero en teal, Carga en el azul
// corporativo oscuro y Compra en línea en neutral. "Sin tipo" queda en ámbar
// como en el resto de la app.

import { Info } from 'lucide-react';
import { TIPO_INGRESO_OPTIONS } from './labels';

export const TIPO_INGRESO_TOOLTIP =
  'Pasajero: impuestos sobre FOB (umbral $200). Carga: sobre CIF (umbral $200). Compra en línea: umbral $300.';

// Color del activo por régimen (excepción deliberada a los tokens Ambiance).
const AMBIANCE_ACTIVO = {
  pasajero_encomienda: 'amb-seg-btn--on-teal',
  carga_encomienda: 'amb-seg-btn--on-blue',
  compra_linea: 'amb-seg-btn--on-neutral',
};

const TipoIngresoControl = ({ value, onChange, disabled = false, compact = false, ambiance = false }) => (
  <div className="inline-flex items-center gap-1.5">
    <div
      role="radiogroup"
      aria-label="Tipo de ingreso"
      className={
        ambiance
          ? 'amb-seg'
          : `inline-flex overflow-hidden rounded-md border border-slate-200 ${
              compact ? 'text-[11px]' : 'text-xs'
            }`
      }
    >
      {TIPO_INGRESO_OPTIONS.map((o, i) => {
        const activo = value === o.value;
        return (
          <button
            key={o.value}
            type="button"
            role="radio"
            aria-checked={activo}
            disabled={disabled}
            onClick={() => !disabled && onChange(o.value)}
            className={
              ambiance
                ? `amb-seg-btn${activo ? ` ${AMBIANCE_ACTIVO[o.value] || 'amb-seg-btn--on-neutral'}` : ''}`
                : `${compact ? 'px-2 py-1' : 'px-2.5 py-1.5'} transition-colors disabled:opacity-50 ${
                    i > 0 ? 'border-l border-slate-200' : ''
                  } ${
                    activo
                      ? 'bg-[var(--brand-teal-soft)] font-semibold text-slate-900'
                      : 'bg-white text-slate-500 hover:bg-slate-50'
                  }`
            }
          >
            {o.label}
          </button>
        );
      })}
    </div>
    <span
      className={ambiance ? 'amb-ico inline-flex' : 'inline-flex text-slate-400'}
      title={TIPO_INGRESO_TOOLTIP}
      aria-label="Información sobre el tipo de ingreso"
      role="img"
    >
      <Info size={13} aria-hidden="true" />
    </span>
    {!value && <span className="text-[10px] font-semibold text-amber-700">Sin tipo</span>}
  </div>
);

export default TipoIngresoControl;
